import { Button, Space } from 'antd';

import StatusTabs from './StatusTabs';
import { Filters } from '../../Components/Common';

const Summary = ({
  statusFilters,
  filters,
  onSelect,
  setSelectedFilters,
  selectedFilters,
  tabsDisabled,
  onFilterApply,
  handleClearAll,
  status
}) => {
  return (
    <div className="summary_filter">
      <section className="status_filter">
        <StatusTabs data={statusFilters} disabled={tabsDisabled} onClick={onSelect} status={status} />
      </section>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}>
        <Space wrap>
          {filters?.filters
            ? filters.filters.map((data) => (
                <Filters
                  key={data?.field}
                  data={data}
                  onFilterApply={onFilterApply}
                  selectedValues={
                    data?.field === 'dateRange'
                      ? {
                          start_date: selectedFilters?.start_date,
                          end_date: selectedFilters?.end_date
                        }
                      : selectedFilters?.[data?.field]
                  }
                  setQuery={setSelectedFilters}
                />
              ))
            : null}
        </Space>
        {Object.keys(selectedFilters).length > 0 && (
          <Button onClick={handleClearAll} style={{ color: '#2cb695' }} type="text">
            Clear All
          </Button>
        )}
      </div>
    </div>
  );
};

export default Summary;
